import { UpArrow } from 'app/assets/images/icons';
import React, { FunctionComponent, useState } from 'react';
import styles from './scrollToTopArrow.module.scss';
interface Props {}
const ScrollToTopArrow: FunctionComponent<Props> = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = window.scrollY;
    if (scrolled > 500) {
      setVisible(true);
    } else if (scrolled <= 500) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  window.addEventListener('scroll', toggleVisible);
  return (
    <div
      data-testid="topArrowContainer"
      className={`${styles.scrollToTopWrapper} ${!visible && styles.hide}`}
    >
      <UpArrow
        data-testid="topArrow"
        className={styles.scrollToTop}
        onClick={scrollToTop}
      />
    </div>
  );
};
// const memoizedScrollToTopArrow = memo(ScrollToTopArrow);
// export default memoizedScrollToTopArrow;
export default ScrollToTopArrow;
